var map = {
	"./0.png": "f2c8",
	"./1.png": "df90",
	"./2.png": "e7db",
	"./3.png": "46d0",
	"./4.png": "4541",
	"./5.png": "3b34",
	"./bg.png": "9e60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98e0";